import React from 'react';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Grid, Cell } from 'formlabs-web-components/Grid';
import { Picture } from 'formlabs-web-components/Media';
import { withTranslation } from 'react-i18next';
import useIsMobile from '../../hooks/useIsMobile';

import ContactSalesForm from '../forms/ContactSalesForm';
import './EmbeddedContactSales.module.css';

const EmbeddedContactSales = ({
  buttonText,
  title,
  path,
  image,
  body,
  image_position
}) => {
  const isMedium = useIsMobile(940);
  const direction =
    image_position === 'right' || image_position === 'left' ? 'x' : 'y';

  const width = {
    image: direction == 'x' ? 8 : null,
    form: direction == 'x' ? 16 : null
  };

  const imageStyles =
    direction == 'y' || isMedium
      ? { maxHeight: '20rem', marginBottom: '-.5rem' }
      : null;

  const imageOrder =
    image_position === 'top' || image_position === 'left' || isMedium
      ? '1'
      : '2';
  const cellOrder =
    image_position === 'top' || image_position === 'left' || isMedium
      ? '2'
      : '1';

  let image_cell;
  if (image && image_position != 'None') {
    image_cell = (
      <Cell mediumSize={width.image} styles={{ order: imageOrder }}>
        <Picture
          largeImage={image}
          fullBleed={true}
          imageStyles={imageStyles}
        />
      </Cell>
    );
  }
  const cell = (
    <Cell
      styles={{ padding: '0px', order: cellOrder }}
      mediumSize={width.form}
      backgroundColor="light-grey"
    >
      <div styleName="form-holder">
        <ContactSalesForm
          path={path}
          onClose={() => this.handleClose()}
          buttonText={buttonText}
          title={title}
          body={body}
          boldTitle
        />
      </div>
    </Cell>
  );
  let CellsInRightOrder = (
    <Grid direction={direction} hasContainer={true}>
      {image_cell} {cell}
    </Grid>
  );
  if (isMedium) {
    CellsInRightOrder = (
      <Grid direction="y" hasContainer={true}>
        {image_cell} {cell}
      </Grid>
    );
  }
  return CellsInRightOrder;
};
export default withTranslation()(DisplayComponent(EmbeddedContactSales));
